import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { V3Style } from "./hostedpages";

// The prebuilt Auth Studio designs, projected to their style config only (GET /hosted-pages/
// brand-templates). Read-only reference data shared by every brand, so it is fetched at most once
// per session and never reset on brand navigation. Presentation metadata (label/description/
// thumbnail) lives in utils/HostedPages/prebuiltTemplates.ts and is joined by `slug`.
export interface PrebuiltTemplateStyle {
  slug: string;
  styleConfig: {
    Light: V3Style;
    Dark: V3Style;
  };
}

export interface BrandTemplatesState {
  templates: PrebuiltTemplateStyle[];
  isLoading: boolean;
  // Only set by a successful fetch - this is the refetch guard, so a failure leaves it false and
  // reopening the Add Styles modal retries.
  isLoaded: boolean;
  errorMessage: string | null;
}

const initialBrandTemplatesState: BrandTemplatesState = {
  templates: [],
  isLoading: false,
  isLoaded: false,
  errorMessage: null
};

export const BrandTemplatesSlice = createSlice({
  name: "brandTemplates",
  initialState: initialBrandTemplatesState,
  reducers: {
    getBrandTemplateStylesRequest(state) {
      state.isLoading = true;
      state.errorMessage = null;
    },
    getBrandTemplateStylesSuccess(state, action: PayloadAction<PrebuiltTemplateStyle[]>) {
      state.isLoading = false;
      state.isLoaded = true;
      state.templates = action.payload;
    },
    // Deliberately no toast: this fetch is triggered by opening a modal, which surfaces the error
    // inline instead.
    getBrandTemplateStylesFailure(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.isLoaded = false;
      state.errorMessage = action.payload;
    }
  }
});

export const { getBrandTemplateStylesRequest, getBrandTemplateStylesSuccess, getBrandTemplateStylesFailure } = BrandTemplatesSlice.actions;

export default BrandTemplatesSlice.reducer;
